<template>
  <b-tr>
    <b-td v-if="displaySelection">
      <template v-if="showHotelName">
        <b-iconstack @click="$emit('toggle')">
          <b-icon icon="square" scale="0.8" stacked />
          <b-icon icon="check"  v-if="selected" scale="0.7" stacked />
        </b-iconstack>
        <!-- <b-icon :icon="selected ? 'check' : 'square'"  /> -->
      </template>
    </b-td>
    <b-td>
      <template v-if="showHotelName">
        <b-icon
          icon="info-circle-fill"
          v-b-tooltip.hover
          :title="packageName || hotelName"
          @click="$emit('info')"
          style="cursor: pointer;" />
      </template>
    </b-td>
    <b-td>
      <template v-if="showHotelName">
        <span :id="'result' + result.index" style="cursor: pointer;">
          <span class="mr-2">
            <strong v-if="displayHotelName && hotelName">
              {{  displayHotelName ? hotelName : '' }}
              <sup class="text-warning" v-if="starsIsNumber">
                <span v-for="star in stars" :key="star">
                  <b-icon icon="suit-heart-fill" class="text-danger" />
                </span>
              </sup>
            </strong>
            <br v-if="displayPackageName && displayHotelName" />
            <span
              v-if="displayPackageName && packageName"
              :class="{
                'font-weight-bold': !displayHotelName,
                'small': displayHotelName
              }"
              >
              {{ (displayPackageName && packageName) ? packageName : '' }}
            </span>
          </span>

          <strong class="ml-2">
            <small v-if="!starsIsNumber" class="text-danger">{{result.stars}}</small>
            <small class="text-warning">{{result.extraStars}}</small>
          </strong>
        </span>
        <b-popover
          :target="'result' + result.index"
          :title="hotelName"
          :delay="{ show: 1000, hide: 0 }"
          triggers="hover"
          placement="bottomright">
          <popOverInfo :result="result.hotelInfo || result"/>
        </b-popover>
      </template>
    </b-td>
    <b-td style="width:35%">
      <span v-b-tooltip.hover :title="noCategories + ' ' + $gettext('categorii de camere disponibile')" class="mr-2" v-if="showCategoriesCollapse">
        <b-icon @click="$emit('categoriesToggle')" :icon="!categoriesCollapsed ? 'dash-square' : 'plus-square'" style="cursor: pointer;"/>
      </span>
      <span v-if="!showCategoriesCollapse" class="px-2">&nbsp;</span><span v-if="showCategoryName" class="text-primary">{{ category.name }}</span>
    </b-td>
    <b-td>
      <span v-b-tooltip.hover :title="noMeals + ' ' + $gettext('tipuri de masa disponibile')" class="mr-2" v-if="showMealsCollapse">
        <b-icon @click="$emit('mealsToggle')" :icon="!mealsCollapsed ? 'dash-square' : 'plus-square'" style="cursor: pointer;"/>
      </span>
      <span v-if="!showMealsCollapse" class="px-2">&nbsp;</span><span class="text-board-basis">{{ meal.label }}</span>
    </b-td>
    <b-td class="text-center">
      <span class="pointer"
        :style="'text-decoration:' + (meal.discount ? 'line-through' : '')"
        :class="meal.discount ? 'info-price':'sale-price'  "
        @click="$emit('priceDetails')"
        >
        {{ getFullPrice({ meal, starRating, fees }) }}<small>{{currency}}</small>
      </span>
      <span class="pointer"
        @click="$emit('priceDetails')"
        v-if="meal.discount"
        :class="meal.discount ? 'sale-price':'info-price'"
        >
        {{ getPrice({ meal, starRating, fees }) }}<small>{{currency}}</small>
      </span>
    </b-td>
    <b-td ></b-td>
    <b-td>
      <div class="d-flex">
        <span v-if="category.isSpecial" class="SPO ml-1" v-b-tooltip.hover :title="$gettext('Special Offer')">
        <b-icon icon="tag-fill" class="text-danger"/>
      </span>
      <span v-if="category.isEarlyBooking" class="BD ml-1" v-b-tooltip.hover :title="$gettext('Early Booking')">
        <b-icon icon="clock" class="text-info"/>
      </span>
      <span v-if="category.isFreePax" class="FC ml-1" v-b-tooltip.hover :title="$gettext('Free Child')">
        <b-icon icon="person-plus-fill"/>
      </span>
      </div>
    </b-td>
    <b-td v-if="transport !='own'">
      <span v-if="transportAva" class="FCAVL" v-b-tooltip.hover :title="$gettext('Available')">
        <b-icon icon="check-circle" class="text-success"/>
      </span>
      <span v-else class="RQNA" v-b-tooltip.hover :title="$gettext('Unavailable')">
        <b-icon icon="slash-circle"/>
      </span>
    </b-td>
    <b-td class="text-center">
     <span v-if="status=='avl'" class="FCAVL" v-b-tooltip.hover :title="$gettext('Available')">
        <b-icon icon="check-circle" class="text-success"/>
      </span>
      <span v-if="status=='req'" class="RQNA" v-b-tooltip.hover :title="$gettext('On Request')">
        <b-icon icon="check-circle"/>
      </span>
      <span v-if="status=='n/a'" class="RQNA" v-b-tooltip.hover :title="$gettext('Unavailable')">
        <b-icon icon="slash-circle"/>
      </span>
    </b-td>
    <b-td v-if="showBook" class="large-td">
      <b-btn
        size="sm"
        :variant="(status == 'req') ? 'secondary' : 'success'"
        type="button"
        @click="$emit('book')"
        v-if="transportAva && status != 'n/a'"
      >{{ (status == 'req') ? $gettext('On Request') : $gettext('Book') }}</b-btn>
    </b-td>
  </b-tr>
</template>

<script>
import model from '../../package/services/model'
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'
// import popOverInfo from './popover_info'
import viewMixin from '../mixins/search_views'

export default {
  // components: { popOverInfo },
  props: {
    meal: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    transport: {
      type: String
    },
    starRating: {
      type: Number,
      default: 0
    },
    hotelName: {
      type: String,
      required: true
    },
    packageName: {
      type: String
    },
    showHotelName: {
      type: Boolean,
      required: false,
      default: false
    },
    showCategoryName: {
      type: Boolean,
      required: false,
      default: true
    },
    showBook: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    selected: {
      type: Boolean
    },
    displaySelection: {
      type: Boolean,
      default: true
    },
    displayPackageName: {
      type: Boolean,
      default: false
    },
    displayHotelName: {
      type: Boolean,
      default: true
    },
    noCategories: {
      type: Number,
      required: true
    },
    noMeals: {
      type: Number,
      required: true
    },
    showCategoriesCollapse: {
      type: Boolean,
      required: true
    },
    categoriesCollapsed: {
      type: Boolean,
      required: true
    },
    showMealsCollapse: {
      type: Boolean,
      required: true
    },
    mealsCollapsed: {
      type: Boolean,
      required: true
    }
  },
  mixins: [viewMixin],
  data () {
    return {
      model,
      categoriesExpanded: true,
      mealExpanded: true
    }
  },
  computed: {
    starsIsNumber () {
      // Try converting the string to an integer
      const intValue = parseInt(this.result.stars, 10) // Base 10 for decimal system

      // Check if it's a valid integer and not NaN
      return !isNaN(intValue) && Number.isInteger(intValue)
    },
    stars () {
      return parseInt(this.result.stars, 10)
    },
    status () {
      if (this.category.hotelIsBlackedOut) return 'n/a'
      if (this.category.hotelIsAvailable) return 'avl'
      return 'req'
    },
    transportAva () {
      if (this.transport === 'own') return true
      return this.category.transportIsAvailable
    }
  },
  methods: {
    getPrice,
    getFullPrice
  }
}
</script>

<style lang="css">
  .pointer {
    cursor:pointer;
  }
  .full-price,
  .info-price {
    font-weight: 400;
  }
  .full-price{
    color:#555;
  }
  .sale-price{
    color: #d13239;
    font-weight: 600;
  }
  .large-td{
    min-width: 110px;
    text-align: right;
  }
</style>
